// extracted by css-extract-rspack-plugin
export default {"margin_link":"R150Report__margin_link--Ha034"};